module.exports = __webpack_public_path__ + "img/nav_b1_img4.ee16a211.png";